import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const localeModules = import.meta.glob<{ default: Record<string, unknown> }>(
  './locales/**/*.json',
  { eager: true },
)

const resources: Record<string, Record<string, Record<string, unknown>>> = {}

for (const [path, mod] of Object.entries(localeModules)) {
  const match = path.match(/^\.\/locales\/([a-z]{2})\/(.+)\.json$/)
  if (!match) continue
  const [, lng, ns] = match
  resources[lng] ??= {}
  resources[lng][ns] = mod.default
}

const namespaces = [
  ...new Set(Object.values(resources).flatMap((byNs) => Object.keys(byNs))),
]

i18n.use(initReactI18next).init({
  resources,
  ns: namespaces,
  defaultNS: 'common',
  lng: 'fr',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
